import * as yup from "yup"

export const validationSchema = yup.object().shape({
    price_level_code: yup.string().label("Price level code").required().max(2, 'Maximum code is 2 characters'),
    price_level_name: yup.string().label("Price level name").required().max(100, "Must be 100 characters or less"),
    description: yup.string().label("Description").optional(),
  })